/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { mockRegistry } from '@gh/core-data';

export const BUILDER_MOCK_DATA = mockRegistry(
  // logRequest(mockRequest({
  //   url: '/bp/rest/system-variables/integration-accounts/accounting/sync-migrated',
  //   method: 'put',
  // })),
  // mockBusinessError({
  //   url: '/bp/rest/email-campaigns/6NWR',
  //   method: 'put',
  //   id: 'msg_no_campaign',
  // }),
  // logRequest(mockRequest({
  //   url: '/bp/rest/email-campaigns/6NWR',
  //   method: 'delete',
  // })),
  // mockReport('CASH_FLOW_FORECAST'),
  // mockRequest({ url: '/bp/rest/jobs/init', method: 'get', data: JOBS_INIT }),
  // mockPagination({ url: '/bp/rest/jobs', data: JOB_LIST }),
  // mockGridLayout('jobs', GRID_LAYOUT_JOBS),
);
